










































































import Vue from 'vue';
import { OutlinedTextInput } from '@/components/ds';
import ProuniFileUpload from '@/components/forms/prouni/ProuniFileUpload.vue';
import {
  ProuniDocument,
  ProuniDocumentStatus,
  ProuniDocumentType,
} from '@/store/modules/prouni/types';

interface DraftEntry {
  key: number;
  description: string;
}

export default Vue.extend({
  name: 'ProuniOtherDocuments',
  components: { OutlinedTextInput, ProuniFileUpload },
  data() {
    return {
      drafts: [] as DraftEntry[],
      nextKey: 0,
      documentTypes: ProuniDocumentType,
      documentStatus: ProuniDocumentStatus,
    };
  },
  computed: {
    existingDocuments(): ProuniDocument[] {
      const documents = (this.$store.getters.prouniDocuments || []) as ProuniDocument[];
      return documents.filter(document => document.documentType === ProuniDocumentType.other);
    },
  },
  methods: {
    addDraft() {
      this.drafts.push({ key: this.nextKey, description: '' });
      this.nextKey += 1;
    },
    removeDraft(key: number) {
      this.drafts = this.drafts.filter(draft => draft.key !== key);
    },
    // The upload action already persisted the document in the store, so the
    // draft can be dropped: it will now render in the "existing" list.
    onDraftUploaded(key: number) {
      this.removeDraft(key);
      this.$emit('changed');
    },
    async removeHandler(id?: number) {
      if (!id) return;
      try {
        await this.$store.dispatch('REMOVE_PROUNI_DOCUMENT', id);
        this.$emit('changed');
      } catch (err) {
        this.$emit('error');
      }
    },
  },
});
